import { Link, useLocation } from "react-router-dom";
import {
  CardsNavIcon,
  CryptoNavIcon,
  HomeNavIcon,
  SettingIcon,
} from "../../icons/NavIcons";

const NAV_ITEMS = [
  { id: "home", label: "Home", path: "/", Icon: HomeNavIcon },
  { id: "cards", label: "Cards", path: "/card", Icon: CardsNavIcon },
  { id: "crypto", label: "Crypto", path: "/v2/crypto", Icon: CryptoNavIcon },
  { id: "settings", label: "Settings", path: "/settings", Icon: SettingIcon },
  // {
  //   id: "manage",
  //   label: "Manage",
  //   path: "/v2/manage_beneficiery",
  //   Icon: ManageNavIcon,
  // },
];

const MobileBottomNav = () => {
  const { pathname } = useLocation();

  const isActive = (path) => {
    if (path === "/") return pathname === "/";
    return pathname === path || pathname.startsWith(`${path}/`);
  };

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-50 border-t border-divider bg-background-surface pb-[env(safe-area-inset-bottom)] shadow-[0_-4px_24px_rgba(0,0,0,0.06)] sm:hidden"
      aria-label="Main navigation"
    >
      <div className="flex items-end justify-around rounded-t-[24px] px-2 pb-2 pt-3">
        {NAV_ITEMS.map(({ id, label, path, Icon }) => {
          const active = isActive(path);

          return (
            <Link
              key={id}
              to={path}
              className="relative flex min-w-[64px] flex-col items-center gap-1 px-2 py-1"
            >
              {active && (
                <span
                  className="pointer-events-none absolute left-1/2 top-1 size-12 -translate-x-1/2 -translate-y-1 rounded-full bg-[#4AB932]/20 blur-md"
                  aria-hidden
                />
              )}

              <span className="relative flex h-6 items-center justify-center">
                <Icon active={active} />
              </span>

              <span
                className={`relative text-xs leading-4 ${
                  active
                    ? "font-semibold text-[#4AB932]"
                    : "font-medium text-text-secondary"
                }`}
              >
                {label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
};

export default MobileBottomNav;
